const WindchillCourse = {
    id: "windchill-plm",

    name: "Windchill Customization using Java, JSP, JDBC",

    hero: {
        title: "Windchill Customization using Java, JSP, JDBC",
        subtitle: "Live & Interactive Online Training",
        logo: "/windchill-plm-logo.webp",
        syllabusPdf: "/syllabus/WINDCHILL-Syllabus.pdf",

        points: [
            "Master Windchill Customization using Java, JSP, and JDBC to build enterprise-grade PLM extensions and automate engineering workflows across the product lifecycle.",

            "Perfect for engineers, PLM consultants, and Java developers aiming for high-growth, high-paying careers in product data management and enterprise system integration.",

            "Gain hands-on experience in customizing Windchill components, workflows, and UI screens, while integrating with backend databases and external systems using JDBC and JSP.",

            "We start from the fundamentals of Java and PLM architecture, making it accessible for both new developers and experienced engineers transitioning into Windchill.",

            "Get trained by Windchill professionals working in top global manufacturing and tech companies, and receive guidance on real-world projects, interviews, and career paths."
        ]
    },

    highlights: [
        {
            title: "High Salary",
            description:
                "“For Windchill Design Engineers with 4 to 5 years of experience, the average CTC ranges from 5 Lakhs to 10 Lakhs. However, Windchill Developers with the same experience can command CTCs of 20 Lakhs to 30 Lakhs.”"
        },
        {
            title: "Good Demand",
            description:
                "“While Windchill Design is a well-known skill among mechanical engineers, there is intense competition for design jobs. On the other hand, Windchill Automation & Customization is a niche expertise, with only a few engineers.”"
        },
        {
            title: "Easier To Learn",
            description:
                "“While Windchill Design is generally easier to learn, Windchill Customization can be more challenging. With our extensive experience in this field, we aim to simplify the process for you with our step by step training.”"
        }
    ],

    whyLearn: [
        {
            title: "Work with a Leading PLM Platform",
            description:
                "Windchill by PTC is a globally adopted PLM system used by major companies like Caterpillar, Raytheon, Mahindra, and Volvo — learning to customize it opens doors to top-tier engineering organizations."
        },
        {
            title: "Java is the Core Language of Windchill",
            description:
                "Windchill is built on Java-based architecture. Learning Java along with JSP and JDBC gives you the core skills to extend, modify, and integrate Windchill functionalities."
        },
        {
            title: "Customize Business Logic & Workflows",
            description:
                "You can develop and deploy custom business logic, workflow tasks, post-actions, and data validations, tailoring Windchill to any organization’s processes."
        },
        {
            title: "Design Custom User Interfaces",
            description:
                "Using JSP (JavaServer Pages), you can customize Windchill UI screens, forms, and dialogs, improving the user experience and aligning it with business needs."
        },
        {
            title: "Enable Backend Data Access & Integration",
            description:
                "JDBC allows you to connect Windchill to external databases or perform advanced operations not exposed via the OOTB UI or APIs — ideal for reporting and analytics."
        },
        {
            title: "Support Digital Transformation Projects",
            description:
                "PLM is central to Industry 4.0 and Digital Thread strategies. Windchill customization lets you build the automations needed for smart factories, MBD, and IoT-driven development."
        },
        {
            title: "Bridge PLM with Other Enterprise Systems",
            description:
                "With Java and JDBC, you can integrate Windchill with ERP, MES, CRM, and other enterprise tools, enabling smooth data flow across departments."
        },
        {
            title: "Build Scalable and Secure Solutions",
            description:
                "Windchill’s Java-based extension framework supports robust, scalable, and secure enterprise applications, making your skills highly valuable in large deployments."
        },
        {
            title: "In-Demand Career Opportunities",
            description:
                "There’s a strong global demand for Windchill customization experts in industries like automotive, aerospace, defense, and heavy engineering — with salaries to match."
        },
        {
            title: "Develop Full-Stack PLM Expertise",
            description:
                "Learning Windchill customization with Java, JSP, and JDBC gives you end-to-end control — from front-end UI to business logic to backend integration."
        }
    ],

    syllabus: [
        {
            name: "Java, JSP & JDBC",
            modules: [
                {
                    number: 1,
                    title: "Java Fundamentals & Environment Setup",
                    topics: [
                        "Introduction to Java",
                        "Java Characteristics & Platform Independence",
                        "Installing JDK, JRE, and Java Compiler",
                        "Eclipse IDE Installation & Setup"
                    ]
                },
                {
                    number: 2,
                    title: "Data Types & Operators",
                    topics: [
                        "Primitive vs Reference (Object) Data Types",
                        "Arithmetic, Logical & Bitwise Operators",
                        "Relational Operators",
                        "Local vs Instance vs Static Variables",
                        "Type Casting in Java"
                    ]
                },
                {
                    number: 3,
                    title: "Control Structures",
                    topics: [
                        "Conditional Statements: if, if-else, switch",
                        "Loops: for, while, do-while",
                        "Loop Control: break, continue"
                    ]
                },
                {
                    number: 4,
                    title: "Object-Oriented Programming (OOP)",
                    topics: [
                        "Core Concepts: Abstraction, Encapsulation, Inheritance, Polymorphism",
                        "Method Overloading & Overriding",
                        "JavaBeans vs POJO",
                        "Getters and Setters",
                        "Method Signature Explained",
                        "Creating Classes and Objects",
                        "Object Reference & Method Invocation",
                        "Constructors: Types and Execution Flow",
                        "Abstract Classes & Methods",
                        "Interface Concepts",
                        "super and final Keywords",
                        "Heap vs Stack Memory in Java"
                    ]
                },
                {
                    number: 5,
                    title: "Advanced Java Features",
                    topics: [
                        "Working with the String Class and Its Methods",
                        "Exception Handling: try, catch, finally, and User-Defined Exceptions",
                        "Working with Java Collections (java.util Package)",
                        "File Handling: Read/Write Operations",
                        "Uploading and Downloading Files in Java",
                        "Use of transient and volatile Keywords",
                        "Thread Safety: Synchronization in Java"
                    ]
                },
                {
                    number: 6,
                    title: "Database Programming with JDBC",
                    topics: [
                        "Introduction to JDBC",
                        "JDBC Features and Architecture",
                        "JDBC Driver Types",
                        "Setting up JDBC in Eclipse",
                        "Establishing Database Connections",
                        "Working with Statement, PreparedStatement, ResultSet, RowSet",
                        "CRUD Operations using JDBC"
                    ]
                },
                {
                    number: 7,
                    title: "Java Web Technologies – Servlets & JSP",
                    topics: [
                        "Introduction to Servlets and Their Role in Web Apps",
                        "Servlet Lifecycle (init(), service(), destroy())",
                        "Session Management Techniques",
                        "JSP Lifecycle and Use Cases",
                        "JSP Elements: Scriptlets, Expressions, Declarations",
                        "Custom Tags in JSP",
                        "Difference Between JSP and Servlets",
                        "Installing Apache Tomcat",
                        "Creating & Deploying a Sample Web Application"
                    ]
                }
            ]
        },

        {
            name: "Windchill PLM",
            modules: [
                {
                    number: 1,
                    title: "Introduction & Navigation",
                    topics: [
                        "Introduction to Windchill & PLM Benefits",
                        "Overview of Windchill Modules & Architecture",
                        "Windchill Versions & PLM Comparison Matrix",
                        "Windchill Database Support & Installation Context",
                        "Navigating the Windchill UI",
                        "Understanding UI Components & Tabs",
                        "Recent Products, Libraries, Projects, & Navigation Tips"
                    ]
                },
                {
                    number: 2,
                    title: "User Operations & System Administration",
                    topics: [
                        "Raising a Case with PTC Support",
                        "Understanding the OOTB Folder Structure",
                        "Eclipse Configuration for Windchill Development",
                        "Product & Library Creation",
                        "Organization and Site Setup",
                        "Customization Tab Overview",
                        "System Administration Basics",
                        "Type and Attribute Management",
                        "User & Group Creation",
                        "Preference Management",
                        "Monitoring Server Status & Logger Settings"
                    ]
                },
                {
                    number: 3,
                    title: "Backend & Configuration",
                    topics: [
                        "Windchill Database Overview & OOTB Table Structure",
                        "Generating and Configuring QML Reports",
                        "Working with Object Initialization Rules",
                        "Using the JCA Debugger for Troubleshooting",
                        "Configuring actions.xml and actionModels.xml",
                        "Managing Resource Bundle Files"
                    ]
                },
                {
                    number: 4,
                    title: "Validation & Wizard Framework",
                    topics: [
                        "Wizard Architecture & Workflow",
                        "Validators Overview",
                        "Registering Pre & Post Validators",
                        "Writing Custom Form Processors",
                        "Registering and Using Data Utilities",
                        "Creating Custom Data Utility Classes (with Examples)"
                    ]
                },
                {
                    number: 5,
                    title: "MVC Framework & Workflow Customization",
                    topics: [
                        "MVC Components Overview",
                        "Calling Java Code via MVC Framework",
                        "Creating New Workflows & Lifecycle Integration",
                        "Linking WTPart with WTDocument",
                        "Creating Parts in Windchill Using File Imports",
                        "Configuring Java Logic in Workflow Robots",
                        "Writing Custom Utilities",
                        "Example: Bulk Download of Primary & Secondary Content from WTDocument Objects"
                    ]
                }
            ]
        }
    ],

    faq: [
        {
            question: "What is Windchill?",
            answer:
                "Windchill is a Product Lifecycle Management (PLM) software developed by PTC. It is designed to help organizations manage the complete lifecycle of their products, from concept and design to manufacturing, service, and retirement. Windchill offers tools for data management, collaboration, process automation, and more, facilitating efficient product development and lifecycle management."
        },
        {
            question: "How do CAA Developers command higher salaries?",
            answer:
                "CAA Developers often receive significantly higher salaries compared to CATIA 3D designers. This is because they create automation tools that can perform tasks that would be challenging for many individuals to accomplish without such tools.\n\nFor a detailed explanation, please view the video located at this page."
        },
        {
            question:
                "I have CAD design experience; will it be beneficial for me in CAD Automation & Customization?",
            answer:
                "Absolutely, having CAD design experience is an advantage. It allows you to fully leverage your design skills and familiarity with CAD tools.\n\nYou can adeptly assess and make informed decisions about which aspects to automate and the value that automation brings.\n\nIn the future, your background can position you to lead teams of both design engineers and developers, bridging the gap between design excellence and cutting-edge automation solutions."
        },
        {
            question: "Can I work on all CAD Customization if I learn one?",
            answer:
                "Yes and No.\n\nIn the first part of the training, you’ll grasp programming concepts that are foundational for all CAD customizations, creating a strong common foundation.\n\nHowever, the CAD API knowledge gained in the second part of the training is tool-specific, tailored to a particular CAD software.\n\nTo work on various CAD customizations, you would need to familiarize yourself with the APIs specific to each tool. Yet, if you master one API thoroughly, you’ll find it relatively straightforward to adapt and learn others independently with minimal effort."
        },
        {
            question:
                "Why should I choose FeesWorth for learning CAD Automation and Customization?",
            answer:
                "When it comes to CAD Automation or Customization, FeesWorth is the most experienced institute, with over a decade of expertise in providing this training.\n\nWe have a unique ability to teach programming to Mechanical Engineers and CAD to software developers, making our training accessible to a diverse audience.\n\nOur success stories and proven track record demonstrate the effectiveness of our approach, ensuring you receive the best education in CAD Automation and Customization."
        },
        {
            question: "Is job guarantee provided with the courses?",
            answer:
                "No, job guarantee is not provided with this course, but job assistance is provided. This is because securing a job largely depends on your personal abilities and the effort you invest in practicing your CAD skills."
        },
        {
            question: "Which programming language is suitable for CAD Customization?",
            answer:
                "For CATIA CAA Customization and Creo Toolkit Customization, C++ is an excellent choice.\n\nFor other CAD tools such as NX, AutoCAD, Solidworks, Inventor, etc., C#.NET or VB.NET are well-suited programming languages."
        },
        {
            question: "What are the current job opportunities in this field?",
            answer:
                "This skill is quite rare, with a limited number of professionals available in the market compared to the growing demand. Consequently, the job opportunities in this field are in high demand and offer promising prospects."
        }
    ],

    videos: [
        {
            category: "What is CAD Customization? (Explained using real project)",
            title: "CAD Customization And Automation Session",
            videoUrl:
                "https://www.youtube.com/embed/VpcpMwvQJy4?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=1\\&forigin=https%3A%2F%2Ffeesworth.com%2Fptc-windchill-plm-customization-course%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com%2F\\&vf=1"
        },
        {
            category: "Real first Day programming class",
            title: "Day 1: Programming Class C#.NET",
            videoUrl:
                "https://www.youtube.com/embed/7U2z7LUMH9g?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=3\\&forigin=https%3A%2F%2Ffeesworth.com%2Fptc-windchill-plm-customization-course%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com\\&vf=1"
        }
    ]
};

export default WindchillCourse;